import * as fotos from '../fotos'
const TeamListData = []

/* ============================================================
   NOVA EV01 - SEASON 24/25
   ============================================================ */
TeamListData.novaev01_2425 = [
  {
    title: 'board',
    members: [
      { name: 'Mariana Santos', role: 'team-leader',        imageSrc: fotos.Mariana_Santos },
      { name: 'Diogo Peixe',    role: 'team-leader',        imageSrc: fotos.Diogo_Peixe },
      { name: 'Afonso Dinis',   role: 'technical-director', imageSrc: fotos.Afonso_Dinis },
      { name: 'Mariana Inácio', role: 'project-manager',    imageSrc: fotos.Mariana_Inacio },
      { name: 'João Balbino',   role: 'finance',            imageSrc: fotos.Joao_Balbino },
    ],
  },
  {
    title: 'aerodynamics',
    members: [
      { name: 'Ângela Rodrigues',    role: 'member', imageSrc: fotos.Angela_Rodrigues },
      { name: 'Cristiano Almeida',   role: 'member', imageSrc: fotos.placeholder },
      { name: 'Francisco Rodrigues', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Mário Fonseca',       role: 'member', imageSrc: fotos.Mario_Fonseca },
      { name: 'Miguel Lourenço',     role: 'member', imageSrc: fotos.Miguel_Lourenco },
      { name: 'Tomás Pinto',         role: 'member', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'chassis',
    members: [
      { name: 'Martim Matias',      role: 'dep-leader', imageSrc: fotos.Martim_Matias },
      { name: 'Beatriz Moniz',      role: 'member',     imageSrc: fotos.Beatriz_Moniz },
      { name: 'Carlos Barbosa',     role: 'member',     imageSrc: fotos.Carlos_Barbosa },
      { name: 'Joaquim Nascimento', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Fidalgo',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Jordão',      role: 'member',     imageSrc: fotos.Rafael_Jordao },
    ],
  },
  {
    title: 'vehicle-dynamics',
    members: [
      { name: 'Gonçalo Ribeiro',   role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'André Amorim',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'José Paúl Marques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Manuel Santos',     role: 'member',     imageSrc: fotos.Manuel_Tiago_Santos },
    ],
  },
  {
    title: 'suspension',
    members: [
      { name: 'Gonçalo Coelho',   role: 'dep-leader', imageSrc: fotos.Goncalo_Coelho },
      { name: 'Vasco Louro',      role: 'dep-leader', imageSrc: fotos.Vasco_Louro },
      { name: 'Guilherme Faria',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Guilherme Gamito', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João Barroso',     role: 'member',     imageSrc: fotos.Joao_Barroso },
      { name: 'João Carvalho',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Marçal',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Marques',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Ricardo Ferreira', role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'electronics',
    members: [
      { name: 'Miguel Caldeirinha',  role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Frederico Henriques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João André Rato',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Fortes',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'software-control',
    members: [
      { name: 'João Garcia',      role: 'dep-leader', imageSrc: fotos.Joao_Garcia },
      { name: 'André Lopes',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Jaime Ferreira',   role: 'member',     imageSrc: fotos.Jaime_Ferreira },
      { name: 'Miguel Torres',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rodrigo Bugalhão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Mega',       role: 'member',     imageSrc: fotos.Tiago_Mega },
      { name: 'Tomás Pedreira',   role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'powertrain',
    members: [
      { name: 'João Cabral',         role: 'dep-leader', imageSrc: fotos.Joao_Cabral },
      { name: 'Carolina Patrão',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'David Amaral',        role: 'member',     imageSrc: fotos.David_Amaral },
      { name: 'Diogo Casaleiro',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Ferreira',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Duarte Esguedelhado', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Inês Monteiro',       role: 'member',     imageSrc: fotos.Ines_Monteiro },
      { name: 'Lourenço Matias',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Ricardo Cascais',     role: 'member',     imageSrc: fotos.Ricardo_Cascais },
      { name: 'Rodrigo Mendão',      role: 'member',     imageSrc: fotos.Rodrigo_Mendao },
      { name: 'Simão Narciso',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'marketing',
    members: [
      { name: 'Rita Mendes',     role: 'dep-leader', imageSrc: fotos.Rita_Mendes },
      { name: 'Antonio Oliveira',role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Daniel Nunes',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Gouveia',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Mariana Neves',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Matos',     role: 'member',     imageSrc: fotos.Pedro_Matos },
      { name: 'Tomás Pratas',    role: 'member',     imageSrc: fotos.Tomas_Pratas },
    ],
  },
  {
    title: 'logistics',
    members: [
      { name: 'Maria Borges',       role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Diogo Algarvio',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Gabriela Gonçalves', role: 'member',     imageSrc: fotos.Gabriela_Gonçalves },
      { name: 'Lourenço Lopes',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Madalena Silva',     role: 'member',     imageSrc: fotos.Madalena_Silva },
      { name: 'Mariana Ribeiro',    role: 'member',     imageSrc: fotos.placeholder },      
      { name: 'Simão Antunes',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Vitor Raimundo',     role: 'member',     imageSrc: fotos.Vitor_Raimundo },
    ],
  },
  {
    title: 'operations',
    members: [
      { name: 'Carmo Cadilha',       role: 'dep-leader', imageSrc: fotos.Carmo_Cadilha },
      { name: 'César Martinho',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Inês Henriques',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Beatriz Romão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Correia',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'corporate-relations',
    members: [
      { name: 'Martim Costa',        role: 'dep-leader', imageSrc: fotos.Martim_Costa },
      { name: 'Duarte Amaral',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Enzo Moreira',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Henrique Cid',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Leonor Viegas', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Sofia Cruz',          role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tomás Sousa',         role: 'member',     imageSrc: fotos.Tomas_Sousa },
      { name: 'Vasco Gouveia',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
];

/* ============================================================
   NOVA EV01 - SEASON 25/26
   ============================================================ */
TeamListData.novaev01_2526 = [
  {
    title: 'board',
    members: [
      { name: 'Martim Costa',   role: 'team-leader',               imageSrc: fotos.Martim_Costa },
      { name: 'Afonso Dinis',   role: 'technical-director',        imageSrc: fotos.Afonso_Dinis },
      { name: 'Martim Matias',  role: 'technical-director',       imageSrc: fotos.Martim_Matias },
      { name: 'Carmo Cadilha',  role: 'project-manager',           imageSrc: fotos.Carmo_Cadilha },
      { name: 'Simão Correia',  role: 'strategy-finance-director', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'aerodynamics',
    members: [
      { name: 'Mário Fonseca',       role: 'dep-leader', imageSrc: fotos.Mario_Fonseca },
      { name: 'Alexandru Rusu',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Peixe',         role: 'member',     imageSrc: fotos.Diogo_Peixe },
      { name: 'Francisco Rodrigues', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'José Tavares',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Miguel Lourenço',     role: 'member',     imageSrc: fotos.Miguel_Lourenco },
      { name: 'Tomás Pinto',         role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'chassis',
    members: [
      { name: 'Martim Matias',      role: 'dep-leader', imageSrc: fotos.Martim_Matias },
      { name: 'Carlos Barbosa',     role: 'member',     imageSrc: fotos.Carlos_Barbosa },
      { name: 'Joaquim Nascimento', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Fidalgo',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Jordão',      role: 'member',     imageSrc: fotos.Rafael_Jordao },
    ],
  },
  {
    title: 'vehicle-dynamics',
    members: [
      { name: 'Manuel Santos',     role: 'dep-leader', imageSrc: fotos.Manuel_Tiago_Santos },
      { name: 'Diogo Filipe',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Francisco Almeida', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Alves',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Valadas',     role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'suspension',
    members: [
      { name: 'Gonçalo Correia', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Guilherme Faria', role: 'member', imageSrc: fotos.placeholder },
      { name: 'João Barroso',    role: 'member', imageSrc: fotos.Joao_Barroso },
      { name: 'João Xisto',      role: 'member', imageSrc: fotos.placeholder },
      { name: 'Ricardo Ferreira',role: 'member', imageSrc: fotos.placeholder },
      { name: 'Simão Cruz',      role: 'member', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'electronics',
    members: [
      { name: 'Bernardo Carmona',    role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'André Dimas',         role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Frederico Henriques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João Garcia',         role: 'member',     imageSrc: fotos.Joao_Garcia },
      { name: 'Miguel Torres',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Fortes',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Mega',          role: 'member',     imageSrc: fotos.Tiago_Mega },
    ],
  },
  {
    title: 'driverless',
    members: [
      { name: 'Jaime Ferreira',   role: 'dep-leader', imageSrc: fotos.Jaime_Ferreira },
      { name: 'Dinis Dashkevych', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João Barata',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tarik Tuna',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'e-powertrain',
    members: [
      { name: 'David Amaral',    role: 'dep-leader', imageSrc: fotos.David_Amaral },
      { name: 'Lourenço Matias', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Narciso',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tomás Martinho',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Wang Nuo',        role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'm-powertrain',
    members: [
      { name: 'João Cabral',     role: 'dep-leader', imageSrc: fotos.Joao_Cabral },
      { name: 'Carolina Patrão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Casaleiro', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Ferreira',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Guilherme Duarte',role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'marketing',
    members: [
      { name: 'Rita Mendes',   role: 'dep-leader', imageSrc: fotos.Rita_Mendes },
      { name: 'João Lourenço', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Lucia Barbosa', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Mariana Neves', role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'logistics',
    members: [
      { name: 'Maria Borges',   role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Lourenço Lopes', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Antunes',  role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'production',
    members: [
      { name: 'Mariana Inácio',     role: 'dep-leader', imageSrc: fotos.Mariana_Inacio },
      { name: 'César Martinho',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Francisco Antunes',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Beatriz Romão',role: 'cost',       imageSrc: fotos.placeholder },
      { name: 'Sara Martins',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'sponsoring',
    members: [
      { name: 'Ana Reis',      role: 'member', imageSrc: fotos.placeholder },
      { name: 'Barbara Matos', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Henrique Cid',  role: 'member', imageSrc: fotos.placeholder },
      { name: 'Mariana Meira', role: 'member', imageSrc: fotos.placeholder },
    ],
  },
];

/* ============================================================
   FS FENIX EVO - SEASON 24/25
   ============================================================ */
TeamListData.fsfenixevo_2425 = [
  {
    title: 'board',
    members: [
      { name: 'Mariana Santos', role: 'team-leader',        imageSrc: fotos.Mariana_Santos },
      { name: 'Diogo Peixe',    role: 'team-leader',        imageSrc: fotos.Diogo_Peixe },
      { name: 'Afonso Dinis',   role: 'technical-director', imageSrc: fotos.Afonso_Dinis },
      { name: 'Mariana Inácio', role: 'project-manager',    imageSrc: fotos.Mariana_Inacio },
      { name: 'João Balbino',   role: 'finance',             imageSrc: fotos.Joao_Balbino },
    ],
  },
  {
    title: 'aerodynamics',
    members: [
      { name: 'Ângela Rodrigues',    role: 'member', imageSrc: fotos.Angela_Rodrigues },
      { name: 'Cristiano Almeida',   role: 'member', imageSrc: fotos.placeholder },
      { name: 'Francisco Rodrigues', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Mário Fonseca',       role: 'member', imageSrc: fotos.Mario_Fonseca },
      { name: 'Miguel Lourenço',     role: 'member', imageSrc: fotos.Miguel_Lourenco },
      { name: 'Tomás Pinto',         role: 'member', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'chassis',
    members: [
      { name: 'Martim Matias',      role: 'dep-leader', imageSrc: fotos.Martim_Matias },
      { name: 'Beatriz Moniz',      role: 'member',     imageSrc: fotos.Beatriz_Moniz },
      { name: 'Carlos Barbosa',     role: 'member',     imageSrc: fotos.Carlos_Barbosa },
      { name: 'Joaquim Nascimento', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Fidalgo',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Jordão',      role: 'member',     imageSrc: fotos.Rafael_Jordao },
    ],
  },
  {
    title: 'vehicle-dynamics',
    members: [
      { name: 'Gonçalo Ribeiro',   role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'André Amorim',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'José Paúl Marques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Manuel Santos',     role: 'member',     imageSrc: fotos.Manuel_Tiago_Santos },
    ],
  },
  {
    title: 'suspension',
    members: [
      { name: 'Gonçalo Coelho',   role: 'dep-leader', imageSrc: fotos.Goncalo_Coelho },
      { name: 'Vasco Louro',      role: 'dep-leader', imageSrc: fotos.Vasco_Louro },
      { name: 'Guilherme Faria',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Guilherme Gamito', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João Barroso',     role: 'member',     imageSrc: fotos.Joao_Barroso },
      { name: 'João Carvalho',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Marçal',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Marques',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Ricardo Ferreira', role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'electronics',
    members: [
      { name: 'Miguel Caldeirinha',  role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Bernardo Carmona',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Frederico Henriques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João André Rato',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Fortes',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'software-control',
    members: [
      { name: 'Gonçalo Correia',  role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'João Garcia',      role: 'dep-leader', imageSrc: fotos.Joao_Garcia },
      { name: 'André Lopes',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Frederico Firmino',role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Jaime Ferreira',   role: 'member',     imageSrc: fotos.Jaime_Ferreira },
      { name: 'Miguel Torres',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rodrigo Bugalhão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Mega',       role: 'member',     imageSrc: fotos.Tiago_Mega },
      { name: 'Tomás Pedreira',   role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'powertrain',
    members: [
      { name: 'David Amaral',        role: 'dep-leader', imageSrc: fotos.David_Amaral },
      { name: 'João Cabral',         role: 'dep-leader', imageSrc: fotos.Joao_Cabral },
      { name: 'Carolina Patrão',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Casaleiro',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Ferreira',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Duarte Esguedelhado', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Guilherme Duarte',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Inês Monteiro',       role: 'member',     imageSrc: fotos.Ines_Monteiro },
      { name: 'Lourenço Matias',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Ricardo Cascais',     role: 'member',     imageSrc: fotos.Ricardo_Cascais },
      { name: 'Rodrigo Mendão',      role: 'member',     imageSrc: fotos.Rodrigo_Mendao },
      { name: 'Simão Narciso',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tomás Martinho',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Wang Nuo',            role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'marketing',
    members: [
      { name: 'Rita Mendes',     role: 'dep-leader', imageSrc: fotos.Rita_Mendes },
      { name: 'Antonio Oliveira',role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Daniel Nunes',    role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Gouveia',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Mariana Neves',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Matos',     role: 'member',     imageSrc: fotos.Pedro_Matos },
      { name: 'Tomás Pratas',    role: 'member',     imageSrc: fotos.Tomas_Pratas },
    ],
  },
  {
    title: 'logistics',
    members: [
      { name: 'Maria Borges',       role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Diogo Algarvio',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Gabriela Gonçalves', role: 'member',     imageSrc: fotos.Gabriela_Gonçalves },
      { name: 'Lourenço Lopes',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Madalena Silva',     role: 'member',     imageSrc: fotos.Madalena_Silva },
      { name: 'Mariana Ribeiro',    role: 'member',     imageSrc: fotos.placeholder },      
      { name: 'Simão Antunes',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Vitor Raimundo',     role: 'member',     imageSrc: fotos.Vitor_Raimundo },
    ],
  },
  {
    title: 'operations',
    members: [
      { name: 'Carmo Cadilha',       role: 'dep-leader', imageSrc: fotos.Carmo_Cadilha },
      { name: 'César Martinho',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Inês Henriques',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Beatriz Romão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Correia',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'corporate-relations',
    members: [
      { name: 'Martim Costa',        role: 'dep-leader', imageSrc: fotos.Martim_Costa },
      { name: 'Duarte Amaral',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Enzo Moreira',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Henrique Cid',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Leonor Viegas', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Sofia Cruz',          role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tomás Sousa',         role: 'member',     imageSrc: fotos.Tomas_Sousa },
      { name: 'Vasco Gouveia',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
];

/* ============================================================
   FS FENIX EVO - SEASON 25/26
   ============================================================ */
TeamListData.fsfenixevo_2526 = [
  {
    title: 'board',
    members: [
      { name: 'Martim Costa',  role: 'team-leader',               imageSrc: fotos.Martim_Costa },
      { name: 'Afonso Dinis',   role: 'technical-director',       imageSrc: fotos.Afonso_Dinis },
      { name: 'Martim Matias',  role: 'technical-director',       imageSrc: fotos.Martim_Matias },
      { name: 'Carmo Cadilha', role: 'project-manager',           imageSrc: fotos.Carmo_Cadilha },
      { name: 'Simão Correia', role: 'strategy-finance-director', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'aerodynamics',
    members: [
      { name: 'Mário Fonseca',       role: 'dep-leader', imageSrc: fotos.Mario_Fonseca },
      { name: 'Alexandru Rusu',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Peixe',         role: 'member',     imageSrc: fotos.Diogo_Peixe },
      { name: 'Francisco Rodrigues', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'José Tavares',        role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Miguel Lourenço',     role: 'member',     imageSrc: fotos.Miguel_Lourenco },
      { name: 'Tomás Pinto',         role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'chassis',
    members: [
      { name: 'Martim Matias',      role: 'dep-leader', imageSrc: fotos.Martim_Matias },
      { name: 'Carlos Barbosa',     role: 'member',     imageSrc: fotos.Carlos_Barbosa },
      { name: 'Joaquim Nascimento', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Pedro Fidalgo',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Jordão',      role: 'member',     imageSrc: fotos.Rafael_Jordao },
    ],
  },
  {
    title: 'vehicle-dynamics',
    members: [
      { name: 'Manuel Santos',     role: 'dep-leader', imageSrc: fotos.Manuel_Tiago_Santos },
      { name: 'Diogo Filipe',      role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Francisco Almeida', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Alves',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Valadas',     role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'suspension',
    members: [
      { name: 'Gonçalo Correia', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Guilherme Faria', role: 'member', imageSrc: fotos.placeholder },
      { name: 'João Barroso',    role: 'member', imageSrc: fotos.Joao_Barroso },
      { name: 'João Xisto',      role: 'member', imageSrc: fotos.placeholder },
      { name: 'Ricardo Ferreira',role: 'member', imageSrc: fotos.placeholder },
      { name: 'Simão Cruz',      role: 'member', imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'electronics',
    members: [
      { name: 'Bernardo Carmona',    role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'André Dimas',         role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Frederico Henriques', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'João Garcia',         role: 'member',     imageSrc: fotos.Joao_Garcia },
      { name: 'Miguel Torres',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Rafael Fortes',       role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tiago Mega',          role: 'member',     imageSrc: fotos.Tiago_Mega },
    ],
  },
  {
    title: 'powertrain',
    members: [
      { name: 'David Amaral',    role: 'dep-leader', imageSrc: fotos.David_Amaral },
      { name: 'João Cabral',     role: 'dep-leader', imageSrc: fotos.Joao_Cabral },
      { name: 'Carolina Patrão', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Casaleiro', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Diogo Ferreira',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Guilherme Duarte',role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Lourenço Matias', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Narciso',   role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Tomás Martinho',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Wang Nuo',        role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'marketing',
    members: [
      { name: 'Rita Mendes',   role: 'dep-leader', imageSrc: fotos.Rita_Mendes },
      { name: 'João Lourenço', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Lucia Barbosa', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Mariana Neves', role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'logistics',
    members: [
      { name: 'Maria Borges',   role: 'dep-leader', imageSrc: fotos.placeholder },
      { name: 'Lourenço Lopes', role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Simão Antunes',  role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'production',
    members: [
      { name: 'Mariana Inácio',     role: 'dep-leader', imageSrc: fotos.Mariana_Inacio },
      { name: 'César Martinho',     role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Francisco Antunes',  role: 'member',     imageSrc: fotos.placeholder },
      { name: 'Maria Beatriz Romão',role: 'cost',       imageSrc: fotos.placeholder },
      { name: 'Sara Martins',       role: 'member',     imageSrc: fotos.placeholder },
    ],
  },
  {
    title: 'sponsoring',
    members: [
      { name: 'Ana Reis',      role: 'member', imageSrc: fotos.placeholder },
      { name: 'Barbara Matos', role: 'member', imageSrc: fotos.placeholder },
      { name: 'Henrique Cid',  role: 'member', imageSrc: fotos.placeholder },
      { name: 'Mariana Meira', role: 'member', imageSrc: fotos.placeholder },
    ],
  },
];

/* ============================================================
   Default keys
   ============================================================ */
TeamListData.novaev01   = TeamListData.novaev01_2526;
TeamListData.fsfenixevo = TeamListData.fsfenixevo_2526;

export default TeamListData;